import { Component, OnInit } from '@angular/core';
import { ExpenseService } from '../../../services/expense.service';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AUTH } from '../../../contants/AUTH';
import { Expense } from '../../../models/expenses/expense';
import { Row } from '../../../models/tables/row';
import { PageOption } from '../../../models/common/pageOption';
import { ExpenseFilter } from '../../../models/expenses/expenseFilter';
import { DateHelper } from '../../../helpers/DateHelper';
import { ROLES } from '../../../contants/ROLES';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { Helper } from '../../../helpers/Helper';
import { PARAMS } from '../../../contants/PARAMS';
import { QUERY_PARAMS } from '../../../contants/QUERY_PARAMS';
import { BudgetService } from '../../../services/budget.service';

@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css']
})
export class ExpenseListComponent implements OnInit {
  	pageOption: PageOption<ExpenseFilter> = new PageOption();
	
	rows: Row<Expense>[] = [];
	budget: number = 0;

	constructor(
		private _expenseService: ExpenseService,
		private _alertService: AlertService,
		private _parameterService: ParameterService,
		private _commonService: CommonService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _budgetService: BudgetService
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new ExpenseFilter();
		this.getBudget();

		this._activatedRoute.queryParams.subscribe(
			params => {
				var filter = new ExpenseFilter();
				if(params[QUERY_PARAMS.IS_DATE_NOW] != 'false'){
					filter.expenseDateFrom = DateHelper.getDateNowString();
				}

				this._parameterService.getCachedParameter<number>(PARAMS.EXPENSE_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
					value => {
						value = Number(value);
						this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
						this.pageOption.pageNumber = 1;
		
						this.pageOption.searchFilter = new ExpenseFilter();
						this.pageOption.searchFilter.expenseDateFrom = DateHelper.getDateNowString();
		
						this.search(filter);
					}
				);
			}
		);
	}

	fetchData(){
		this._expenseService.getExpensesList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let index = ((result.pageNumber - 1) * this.pageOption.pageSize);
					result.data.forEach(x => {
						let row = new Row<Expense>();
						row.status = 'loaded';
						row.object = x;
						this.rows[index] = row;
						index++;
					});
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	saveRow(index: number) {
		let expense = this.rows[index].object;

		if (expense.id == undefined || expense.id == 0) {
			this.createDailyTrip(index, expense);
		}
		else {
			this.updateDailyTrip(index, expense);
		}
	}

	addRow() {
		let row = new Row<Expense>();
		row.status = 'new';
		row.object = new Expense();
		row.object.id = 0;
		row.object.expenseDate = DateHelper.getDateNowString();
		this.rows.push(row);
	}

	removeRow(index: number){
		let id = this.rows[index].object.id;
		this.rows.splice(index, 1);

		//call delete
		if(id != 0){
			this._expenseService.deleteExpense(id).subscribe(
				result => {
					if(result == undefined){
						this._alertService.showGenericError();
					}
					else if(result.errors.length > 0){
						this._alertService.displayErrorResult(result);
					}
				}
			);
		}
	}

	goToFormView(id: number){
		this._router.navigate([APP_ROUTES.expenseForm.replace('/:id', ''), id]);
	}

	needsVehicleId(index: number){
		let expenseType = this.rows[index].object.expenseType;
		if(expenseType == undefined || expenseType == null){
			return false;
		}

		if(expenseType.toUpperCase().indexOf('TRUCK') != -1){
			return true;
		}

		return false;
	}

	private createDailyTrip(index: number, newExpense: Expense) {
		this._expenseService.addExpense(newExpense).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Expense saved.')
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateDailyTrip(index: number, existingExpense: Expense) {
		this._expenseService.updateExpense(existingExpense).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Expense data updated.');
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateObject(index: number, object: Expense){
		this.rows[index].object = object;
		this.rows[index].hasError = false;
		this.getBudget();
	}

	search(filter: ExpenseFilter) {
		if(filter != null){
			this.pageOption.searchFilter.expenseDateFrom = Helper.isNullOrUndefined(filter.expenseDateFrom) ? '' : filter.expenseDateFrom;
			this.pageOption.searchFilter.expenseDateTo = Helper.isNullOrUndefined(filter.expenseDateTo) ? '' : filter.expenseDateTo;
			this.pageOption.searchFilter.expenseType = Helper.isNullOrUndefined(filter.expenseType) ? '' : filter.expenseType;
		}

		this.rows = []; //reset array
		this.fetchData();
	}

	getTotal(){
		let totalAmount = 0;
		this.rows.forEach(row => {
			let value = Number(row.object.amount);
			totalAmount += isNaN(value) ? 0 : value;
		})

		return totalAmount;
	}

	private getBudget(){
		this._budgetService.getTotalBudget().subscribe(
			result => {
				if(result != undefined){
					this.budget = result;
				}
			}
		);
	}

	saveAll() {
		for(let index = 0; index < this.rows.length; index++){
			this.saveRow(index);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/expenses/expense-list/expense-list.component.ts